import Vue from 'vue';
import versionsApi from 'api-client/versions';

const versionsModule = {
  state: {
    appVersions: {}
  },
  getters: {
    appVersions: state => (appId) => {
      return state.appVersions[appId] ? state.appVersions[appId] : []
    }
  },
  mutations: {
    setAppVersions(state, {appId, os, data}) {
      if (!state.appVersions[appId]) {
        Vue.set(state.appVersions, appId, {});
      }
      Vue.set(state.appVersions[appId], os, data);
    }
  },
  actions: {
    fetchAppVersions({commit}, {appId, os}) {
      commit('setIsLoading', true);

      return versionsApi.getAppVersions(appId, os)
        .then((appVersionResponse) => {
          commit('setAppVersions', {appId, os, data: appVersionResponse});
          commit('setIsLoading', false);
        })
        .catch(() => {
          commit('setIsLoading', false);
        });
    },
    updateAppVersion({commit}, {appCode, os, stableVersion, criticalVersion, suggestedUpdateDatetime, suggestedUpdateMessage, criticalUpdateDatetime, criticalUpdateMessage, appUpdateLink}) {
      commit ('setIsLoading', true);
      return versionsApi.updateAppVersion(appCode, os, stableVersion, criticalVersion, suggestedUpdateDatetime, suggestedUpdateMessage, criticalUpdateDatetime, criticalUpdateMessage, appUpdateLink)
        .then(() => {
          commit ('setIsLoading', false);
        })
        .catch(() => {
          commit ('setIsLoading', false);
        });
    }
  }
};

export default versionsModule;